module.exports = "https://r.zoocdn.com/_next/static/images/place-holder-image-d1bc3d35ada506fca21c38b293c63da1.jpg";